import { AxiosInstance } from 'axios';

export interface CommentDTO {
  id: string;
  postId: string;
  authorId: string;
  content: string;
  parentId?: string;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
  author?: {
    id: string;
    username: string;
    firstName: string;
    lastName: string;
    displayName?: string;
    avatarUrl?: string;
  };
  replies?: CommentDTO[];
}

export interface CommentListResponse {
  success: boolean;
  data: CommentDTO[];
}

export interface CommentDetailResponse {
  success: boolean;
  data: CommentDTO;
  message?: string;
}

export interface CreateCommentParams {
  postId: string;
  content: string;
  parentId?: string;
}

export interface UpdateCommentParams {
  content: string;
}

export default class CommentService {
  constructor(private axios: AxiosInstance) {}

  // 댓글 목록 조회 (Public)
  getCommentsByPostId = async (postId: string): Promise<CommentListResponse> => {
    const { REACT_APP_API_ENDPOINT } = process.env;
    this.axios.defaults.baseURL = REACT_APP_API_ENDPOINT;
    const { data } = await this.axios.get(`/comment/post/${postId}`);
    return data;
  };

  // 댓글 작성 (Auth Required)
  createComment = async (params: CreateCommentParams): Promise<CommentDetailResponse> => {
    const { REACT_APP_API_ENDPOINT } = process.env;
    this.axios.defaults.baseURL = REACT_APP_API_ENDPOINT;
    const { data } = await this.axios.post('/comment', params);
    return data;
  };

  // 댓글 수정 (Auth Required)
  updateComment = async (id: string, params: UpdateCommentParams): Promise<CommentDetailResponse> => {
    const { REACT_APP_API_ENDPOINT } = process.env;
    this.axios.defaults.baseURL = REACT_APP_API_ENDPOINT;
    const { data } = await this.axios.put(`/comment/${id}`, params);
    return data;
  };

  // 댓글 삭제 (Auth Required)
  deleteComment = async (id: string): Promise<{ success: boolean; message: string }> => {
    const { REACT_APP_API_ENDPOINT } = process.env;
    this.axios.defaults.baseURL = REACT_APP_API_ENDPOINT;
    const { data } = await this.axios.delete(`/comment/${id}`);
    return data;
  };
}






